import React from 'react';
import { Box, Paper, Stack, Typography } from '@mui/material';

export const nativeSelectProps = { select: { native: true }, inputLabel: { shrink: true } };
export const shrinkLabelProps = { inputLabel: { shrink: true } };

const ScheduleFormSection = ({ title, description, actions, children }) => (
  <Paper variant="outlined" sx={{ p: { xs: 2, sm: 3 } }}>
    <Stack
      direction={{ xs: 'column', sm: 'row' }}
      spacing={1}
      sx={{ mb: 2, justifyContent: 'space-between', alignItems: { xs: 'stretch', sm: 'center' } }}
    >
      <Box>
        <Typography variant="h6">{title}</Typography>
        {description && (
          <Typography variant="body2" color="text.secondary">{description}</Typography>
        )}
      </Box>
      {actions}
    </Stack>
    {children}
  </Paper>
);

export default ScheduleFormSection;
